import { render } from "./service_utilize.html?vue&type=template&id=3ded0efa&external"
import script from "./service_utilize.js?vue&type=script&lang=js&external"
export * from "./service_utilize.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__